import Header from './components/Header';
import CallMeForm from './components/CallMeForm';
import Body from './components/Body';
import Footer from './components/CommenFooterComponent/index';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import Navbar from './components/Navbar';
import "@fontsource/poppins";

import './App.css';
import Contact from './components/Contact';

function App() {

  const appVersion = appversion.version;

  return (
    <>
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
     metaFileDirectory={ "." }        >

      <Navbar />
      <Header />
      <Contact />
      <Body />
      <Footer />
      </CacheBuster>
    </>
  );
}

export default App;
